import {writable} from 'svelte/store';
import {GROUP_TYPE} from "../lib/constants";
import members from "./members";


const {set, update, subscribe} = writable({
    list: [],
    editGroupId: null,
    editGroupType: null,
});

const groups = {
    set,
    update,
    subscribe,
    unselectGroups: () => {
        groups.update(obj => {
            obj.list.map(group => {
                group.selected = false;
            });
            return obj;
        })
    },
    selectGroups: selected => {
        if (selected.length) {
            groups.update(obj => {
                selected.map(id => {
                    let group = obj.list.find(group => group.id == id);
                    if (group) {
                        group.selected = true;
                    }
                });
                return obj;
            })
        }
    },
    editGroup: (id, type = null) => {
        update(obj => {
            obj.editGroupId = id;
            if (type !== null) {
                obj.editGroupType = type;
            }
            return obj;
        })
    },
    closeGroup: () => {
        update(obj => {
            obj.editGroupId = null;
            obj.editGroupType = null;
            return obj;
        })
    },
    deleteGroup: id => {
        groups.update(obj => {
            let group = obj.list.find(x => x.id === id);
            if (group.type === GROUP_TYPE.GROUP_MEMBERS) {
                // remove group from members
                members.removeGroup(id);
            }
            const list = obj.list.filter(g => g.id != id);
            obj.list = list;
            return obj;
        })
    },
    updateGroup: group => {
        update(obj => {
            let index = obj.list.findIndex(g => g.id == group.id);
            if (index > -1) {
                obj.list[index] = group;
            } else {
                obj.list = [group, ...obj.list];
            }

            return obj;
        })
    },
}

export default groups;